export default {"src":"/_next/static/media/ic_login_kakao.95fb9faa.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};